import * as React from 'react';
import { Diagnosis } from '../../Profile/ProfileFields';
import { styles, promptSpacing } from './Styles';

export default ({relationship, firstName}) => (
		<fieldset className={styles.fieldset}>
				<legend className={styles.legend}>Health Information</legend>
				<div>
					<div style={promptSpacing}>
						Enter any of <b>{relationship == 'myself' ? 'your' : `${firstName}'s`}</b> medical diagnoses...
					</div>
						<Diagnosis />
				</div>
		</fieldset>
);



// WEBPACK FOOTER //
// ./src/app/containers/Wizard/Pages/Health.tsx